import {
    AfterViewInit,
    Component,
    EventEmitter,
    HostListener,
    Input,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import {
    AngularSignaturePadModule,
    NgSignaturePadOptions,
    SignaturePadComponent
} from '@almothafar/angular-signature-pad';
import {TranslateModule} from "@ngx-translate/core";
import {NgIf} from "@angular/common";
import {ServerDetectService} from '../../../services/server-detect.service';
import {GuidService} from "../../../services/guid.service";

@Component({
    selector: 'app-sig-pad',
    standalone: true,
    imports: [
        AngularSignaturePadModule,
        TranslateModule,
        NgIf
    ],
    templateUrl: './sig-pad.cmp.html'
})
export class SignaturePadPage implements OnInit, AfterViewInit {
    wrapId: string = GuidService.newId();
    @ViewChild('signature') public signaturePad: SignaturePadComponent;
    initialized: boolean;
    @Input() signature: string;
    @Output() signatureChange: EventEmitter<string> = new EventEmitter();

    signaturePadOptions: NgSignaturePadOptions = { // passed through to szimek/signature_pad constructor
        canvasWidth: 500,
        canvasHeight: 300,
        backgroundColor: 'white',
        canvasBackground: 'white'
    };

    constructor(private serverDetectService: ServerDetectService) {
        // no-op
    }

    ngOnInit() {
        if (this.serverDetectService.isServer()) return;
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: Event) {
        this.setSigPadWidth();
    }

    setSigPadWidth() {
        const wrapWidth = document.getElementById(this.wrapId);
        this.initialized = true;
        const width = wrapWidth.clientWidth;
        const height = width / 2;

        setTimeout(() => {
            console.log(width, height);
            this.signaturePad.getCanvas().width = width;
            this.signaturePad.getCanvas().height = height;
            this.signaturePadOptions.canvasWidth = width;
            this.signaturePadOptions.canvasHeight = height;
        });
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.setSigPadWidth();
        });
    }

    drawComplete(event: MouseEvent | Touch) {
        // will be notified of szimek/signature_pad's onEnd event
        const newSig = this.signaturePad.toDataURL();
        if (newSig != this.signature) {
            this.signature = newSig;
            this.signatureChange.emit(newSig);
        }
    }

    clearSignature() {
        this.signaturePad.clear();
        this.signature = null;
        this.signatureChange.emit(null);
    }

}
